// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/akash.css
// module id = 1284
// module chunks = 34